import Swup from 'swup'
import activeMenu from './components/activeMenu'
import Carousel from './components/Carousel'
import LightBox from './components/Lightbox'
const swup = new Swup()
function init(){
  new activeMenu()
  new Carousel()
  new LightBox()
  window.scrollTo(0, 0)
}
init()

swup.on('contentReplaced', init)
